export default [
  {
    header: 'Финансы',
  },
  {
    title: 'Финансы',
    route: 'finance',
    icon: 'DollarSignIcon',
    tagVariant: 'light-warning',
  },
]
